import { NgClass, NgIf, NgStyle } from '@angular/common';
import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FuseConfirmationConfig } from '@fuse/services/confirmation/confirmation.types';

@Component({
    selector     : 'fuse-confirmation-dialog',
    templateUrl  : './dialog.component.html',
    styles       : [
        `
            .fuse-confirmation-dialog-panel {
                @screen md {
                    @apply w-128;
                }

                &.cdk-overlay-pane,
                .mat-mdc-dialog-container,
                .mdc-dialog__container,
                .mdc-dialog__surface,
                .mat-mdc-dialog-surface {
                    --mdc-dialog-container-color: transparent !important;
                    --mdc-dialog-container-elevation-shadow: none !important;
                    background: transparent !important;
                    background-color: transparent !important;
                    box-shadow: none !important;
                    border: none !important;
                    outline: none !important;
                }
                
                .mat-mdc-dialog-container .mat-mdc-dialog-surface {
                    padding: 0 !important;
                    border-radius: 2rem !important;
                    background: transparent !important;
                    background-color: transparent !important;
                    box-shadow: none !important;
                    overflow: visible !important;
                }
            }
        `,
    ],
    encapsulation: ViewEncapsulation.None,
    standalone   : true,
    imports      : [NgIf, MatButtonModule, MatDialogModule, MatIconModule, NgClass, NgStyle],
})
export class FuseConfirmationDialogComponent
{
    /**
     * Constructor
     */
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: FuseConfirmationConfig,
        private dialogRef: MatDialogRef<FuseConfirmationDialogComponent>
    )
    {
    }

    onCloseMenu(): void {
        this.dialogRef.close();
    }

    isHexColor(color?: string): boolean {
        if (!color) return false;
        return color.startsWith('#') || color.startsWith('rgb');
    }

    getHexRgba(color: string, opacity: number): string {
        if (!color.startsWith('#')) return color;
        
        let hex = color.replace('#', '');
        if (hex.length === 3) {
            hex = hex.split('').map(char => char + char).join('');
        }
        
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);
        
        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    }
}